module.exports = __webpack_public_path__ + "media/images/og-fa6e8de9be62343fc797cd3f29c0b948.png";